// core/notify.js — toasts centralizados (substitui alert()/confirm() espalhados).
//
// Origem (monólito): linhas 9671-9678 (CSS .mbo-toast) e 9808-9814
// (mboShowToast) do legacy/App_Eloquence_v18_FREQ_COMPLETA.html.
//
// Decisões:
//  - Toast único reutilizado (não empilha). Mesma UX da v18.
//  - Cria o elemento no primeiro uso — zero markup no index.html.
//  - Tipos: 'info' (default), 'success', 'error'.
//  - Duração configurável (default 3000ms, igual ao monólito).
//  - Estilos aplicados via CSS inline no elemento (Shadow DOM é overkill aqui)
//    + data-type para hook de CSS customizado opcional.
//
// Uso:
//   import { notify } from './core/notify.js';
//   notify.info('Carregando alunos...');
//   notify.success('Frequência registrada!');
//   notify.error('Falha na API. Tente novamente.');
//   const close = notify.loading('Sincronizando...');  // retorna função de fechar
//   close();
//
//   // Confirmação (substitui window.confirm):
//   const ok = await notify.confirm('Remover este lembrete?');
//   if (ok) { ... }

const COLORS = {
  info: '#0A0A0A',
  success: '#34c759',
  error: '#ff3b30',
  loading: '#0A0A0A',
};

let toastEl = null;
let hideTimer = null;

function ensureToastEl() {
  if (toastEl) return toastEl;
  toastEl = document.createElement('div');
  toastEl.id = 'eloq-toast';
  toastEl.setAttribute('role', 'status');
  toastEl.setAttribute('aria-live', 'polite');
  Object.assign(toastEl.style, {
    position: 'fixed',
    bottom: '100px',
    left: '50%',
    transform: 'translateX(-50%) translateY(100px)',
    background: COLORS.info,
    color: '#fff',
    padding: '14px 24px',
    borderRadius: '12px',
    fontSize: '13px',
    fontWeight: '600',
    zIndex: '9999',
    opacity: '0',
    transition: 'all 0.3s ease',
    pointerEvents: 'none',
    maxWidth: '90vw',
    textAlign: 'center',
  });
  document.body.appendChild(toastEl);
  return toastEl;
}

function show(message, type = 'info', durationMs = 3000) {
  const el = ensureToastEl();
  el.textContent = message;
  el.dataset.type = type;
  el.style.background = COLORS[type] || COLORS.info;
  el.style.opacity = '1';
  el.style.transform = 'translateX(-50%) translateY(0)';

  if (hideTimer) clearTimeout(hideTimer);
  if (durationMs > 0) {
    hideTimer = setTimeout(hide, durationMs);
  }
}

function hide() {
  if (!toastEl) return;
  toastEl.style.opacity = '0';
  toastEl.style.transform = 'translateX(-50%) translateY(100px)';
  if (hideTimer) { clearTimeout(hideTimer); hideTimer = null; }
}

/**
 * Toast persistente (sem timeout). Retorna função para fechar manualmente.
 * Útil para operações longas: `const close = notify.loading('...'); ...; close();`
 */
function loading(message = 'Carregando...') {
  show(message, 'loading', 0);
  return hide;
}

/**
 * Confirmação assíncrona baseada em window.confirm() (temporário).
 * Na pós-v19, pode ser trocado por modal customizado sem mudar a API.
 */
function confirm(message) {
  return Promise.resolve(window.confirm(message));
}

export const notify = {
  info:    (msg, ms) => show(msg, 'info', ms),
  success: (msg, ms) => show(msg, 'success', ms),
  error:   (msg, ms) => show(msg, 'error', ms ?? 4500),
  loading,
  hide,
  confirm,
};
